import { render, staticRenderFns } from "./confirm-iybr-delete-modal.vue?vue&type=template&id=73637378"
import script from "./confirm-iybr-delete-modal.ts?vue&type=script&lang=ts&external"
export * from "./confirm-iybr-delete-modal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73637378')) {
      api.createRecord('73637378', component.options)
    } else {
      api.reload('73637378', component.options)
    }
    module.hot.accept("./confirm-iybr-delete-modal.vue?vue&type=template&id=73637378", function () {
      api.rerender('73637378', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/in-year-budget-requests/view-in-year-budget-request/confirm-iybr-delete-modal/confirm-iybr-delete-modal.vue"
export default component.exports